module.exports = __webpack_public_path__ + "posture/static/img/head_lean_left.d669539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/head_lean_left.png
// module id = s+mH
// module chunks = 1